import {
  pipe,
  values,
  map,
  equals,
  reduce,
  all,
  prop,
  chain,
  nth,
  filter,
  propEq,
  groupBy,
} from 'ramda'
import getNormalizedQuantity from './getNormalizedQuantity.js'

export const segmentlessDealQuantity = pipe(values, nth(0))

export function segmentlessQuantitiesByProductGroupProductKey({ bookingDeal, logError }) {
  return pipe(
    prop('products'),
    filter(propEq('isSegmentless', true)),
    groupBy(prop('ProductGroupProductKey')),
    map(map(p => getNormalizedQuantity(logError)(p)(p.ProductQuantity))),
  )(bookingDeal)
}
